import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { BRAND, SERVICES } from "../data/siteData";

export default function Footer() {
  return (
    <footer className="bg-[#0C0E0D] text-[#FBF9F5]">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <Logo className="h-10 w-10" />
              <span className="font-display text-2xl font-black tracking-tight">SKLOCCOM</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#FBF9F5]/60">
              Precision lawn care, bespoke gardens and four-season property craft across Southern Ontario.
            </p>
          </div>

          <div>
            <p className="font-mono-x text-xs font-semibold uppercase tracking-[0.25em] text-[#72B043]">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-link-home" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">Home</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">Services & Rates</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">About the Crew</Link></li>
              <li><Link to="/gallery" data-testid="footer-link-gallery" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">Selected Works</Link></li>
              <li><Link to="/booking" data-testid="footer-link-booking" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">Book a Free Visit</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">Get a Quote</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-mono-x text-xs font-semibold uppercase tracking-[0.25em] text-[#72B043]">Services</p>
            <ul className="mt-5 space-y-3 text-sm">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.id}>
                  <Link to="/services" className="text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono-x text-xs font-semibold uppercase tracking-[0.25em] text-[#72B043]">Get in Touch</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a href={`tel:${BRAND.phone}`} data-testid="footer-phone-link" className="flex items-center gap-3 text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">
                  <Phone size={15} className="shrink-0" /> {BRAND.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-[#FBF9F5]/70 transition-colors hover:text-[#72B043]">
                  <Mail size={15} className="shrink-0" /> {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#FBF9F5]/70">
                <MapPin size={15} className="shrink-0" /> {BRAND.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-[#FBF9F5]/10 pt-6 text-xs text-[#FBF9F5]/40">
          © 2026 Skloccom Lawn & Garden Care. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
